import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    IGetUnitedLessonsCategoriesPayload,
    IUnitedInitialState,
    IUnitedLessonsGroupPayload,
    IUnitedPayload
} from "../types";
import {GetDeleteUnited, GetUnited, GetUnitedLessonGroups,} from "../store/thunk";
import {ITranslation} from "../../../../types";



const initialState: IUnitedInitialState = {
    unitedLessons: [],
    isLoadingUnited:true,
    isViewRestoreUnited:false,
    selectedUnitedIDs:[],
    unitedLessonsRestore:[],
    unitedLessonsGroup:[],
    unitedLessonsCategories:[],


}

const unitedLessonsSlice = createSlice({
    name: "unitedLessons",
    initialState,
    reducers: {
        setUnited:(state,action: PayloadAction<IUnitedPayload[]>) => {
            state.unitedLessons = action.payload;
        },
        setIsViewRestoreUnited:(state)=>{
            state.isViewRestoreUnited= !state.isViewRestoreUnited
        },
        setSelectedUnitedIDs: (state, action) => {
            state.selectedUnitedIDs = action.payload
        },
        deletedUnited: (state, action: PayloadAction<number>) => {
            state.unitedLessons = state.unitedLessons.filter(elem => elem.id !== action.payload);
        },
        updateUnited: (state, action: PayloadAction<IUnitedPayload>) => {
            state.unitedLessons = state.unitedLessons.map(elem => elem.id === action.payload.id ? {...elem, ...action.payload} : elem);
        },
        setRestoreUnited: (state, action) => {
            state.unitedLessonsRestore = action.payload
        },
        deletedRestoreUnited: (state, action) => {
            state.unitedLessonsRestore = state.unitedLessonsRestore.filter(elem => elem.id !== action.payload);
        },
        setUniteLessonsGroups: (
            state,
            action: PayloadAction<{ data: IUnitedLessonsGroupPayload[]; defaultLanguage: string }>
        ) => {
            const { data, defaultLanguage } = action.payload;



            state.unitedLessonsGroup = data.map((item) => {
                const getSingleTranslation = (translations: ITranslation[]) =>
                    translations?.find((t) => t.slug === defaultLanguage) || null;

                return {
                    ...item,
                    subject: item.subject
                        ? {
                            ...item.subject,
                            translations: getSingleTranslation(item.subject.translations)
                                ? [getSingleTranslation(item.subject.translations)!]
                                : [],
                        }
                        : null,
                    faculty: item.faculty
                        ? {
                            ...item.faculty,
                            translations: getSingleTranslation(item.faculty.translations)
                                ? [getSingleTranslation(item.faculty.translations)!]
                                : [],
                        }
                        : null,
                    educational_program: item.educational_program
                        ? {
                            ...item.educational_program,
                            translations: getSingleTranslation(item.educational_program.translations)
                                ? [getSingleTranslation(item.educational_program.translations)!]
                                : [],
                        }
                        : null,

                };
            });

        },
        clearUnitedData:(state)=>{
            state.unitedLessonsGroup = []
        },
        setUnitedLessonsCategories: (
            state,
            action: PayloadAction<IGetUnitedLessonsCategoriesPayload[]>
        ) => {
            state.unitedLessonsCategories = action.payload.map((elem) => ({
                ...elem,
                grouped_teaching_types: JSON.parse(elem.grouped_teaching_types),
                united_lessons_groups: JSON.parse(elem.united_lessons_groups),
            }));
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetUnited.pending, (state) => {
                state.isLoadingUnited = true;
            })
            .addCase(GetUnited.fulfilled, (state) => {
                state.isLoadingUnited = false;
            })
            .addCase(GetUnited.rejected, (state) => {
                state.isLoadingUnited = false;
            })
            .addCase(GetDeleteUnited.pending, (state) => {
                state.isLoadingUnited = true;
            })
            .addCase(GetDeleteUnited.fulfilled, (state) => {
                state.isLoadingUnited = false;
            })
            .addCase(GetDeleteUnited.rejected, (state) => {
                state.isLoadingUnited = false;
            })
            .addCase(GetUnitedLessonGroups.pending, (state) => {
                state.isLoadingUnited = true;
            })
            .addCase(GetUnitedLessonGroups.fulfilled, (state) => {
                state.isLoadingUnited = false;
            })
            .addCase(GetUnitedLessonGroups.rejected, (state) => {
                state.isLoadingUnited = false;
            })
    },
})


export const {
    setUnited,
    setIsViewRestoreUnited,
    setSelectedUnitedIDs,
    deletedUnited,
    updateUnited,
    setRestoreUnited,
    deletedRestoreUnited,
    setUniteLessonsGroups,
    clearUnitedData,
    setUnitedLessonsCategories
}=unitedLessonsSlice.actions

export default unitedLessonsSlice